export const dataTableFooterPropsMixin = {
    data: function () {
        return {
            footerProps: {
                itemsPerPageOptions: [12, 24, 36, 48, -1]
            }
        }
    }
}